// src/modules/app-views/toolbox/pages/Document/components/ToolboxDocumentCardHeaderColumn3.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleColumn from 'components/SimpleComponents/SimpleColumn';
import { EditOutlined } from '@ant-design/icons';
import { parseDateToDisplay } from 'utils/helpers';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const ToolboxDocumentCardHeaderColumn3 = ({
  showUpdatedAt = true,
  ...record
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const updatedAt =
    (record?._metadata?.audit?.updatedAt &&
      parseDateToDisplay({ date: record._metadata.audit.updatedAt })) ||
    (record?.updatedAt && parseDateToDisplay({ date: record.updatedAt }));

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const items = [
    {
      key: 'updatedAt',
      icon: <EditOutlined />,
      label: updatedAt,
      tooltipText: translateX('last_update'),
      tooltipPlacement: 'right',
      onClick: null,
      hidden: !showUpdatedAt,
    },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return <SimpleColumn items={items?.filter(i => i?.label && !i.hidden)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ToolboxDocumentCardHeaderColumn3;

// *******************************************************************************
// HELPERS
// *******************************************************************************
